import "./ApplyJobModal.css";

import { useState } from "react";
import { createPortal } from "react-dom";

import {
  FaTimes,
  FaPaperPlane,
} from "react-icons/fa";

const API = "http://localhost:3001/applications";

function ApplyJobModal({

  job,

  showModal,

  setShowModal,

}) {

  /* ==========================================================
                        STATES
  ========================================================== */

  const [showSuccess, setShowSuccess] = useState(false);

  const [formData, setFormData] = useState({

    fullname: "",

    email: "",

    phone: "",

    registrationNo: "",

    resume: "",

    coverLetter: "",

  });

  /* ==========================================================
                        VOICE
  ========================================================== */

  const speak = (text) => {

    window.speechSynthesis.cancel();

    const speech = new SpeechSynthesisUtterance(text);

    speech.lang = "en-GB";

    speech.rate = 0.9;

    speech.pitch = 1;

    speech.volume = 1;

    const voices = window.speechSynthesis.getVoices();

    const femaleVoice = voices.find(

      (voice) =>

        voice.lang.startsWith("en") &&

        voice.name.toLowerCase().includes("female")

    );

    if (femaleVoice) {

      speech.voice = femaleVoice;

    }

    window.speechSynthesis.speak(speech);

  };

  /* ==========================================================
                      HANDLE INPUT
  ========================================================== */

  const handleChange = (e) => {

    const {

      name,

      value,

    } = e.target;

    setFormData((prev) => ({

      ...prev,

      [name]: value,

    }));

  };

  /* ==========================================================
                      HANDLE SUBMIT
  ========================================================== */

  const handleSubmit = async (e) => {

    e.preventDefault();

    const application = {

      ...formData,

      jobId: job.id,

      company: job.company,

      position: job.title,

      salary: job.salary,

      location: job.location,

      type: job.type,

      qualification: job.qualification,

      experience: job.experience,

      vacancies: job.vacancies,

      deadline: job.deadline,

      description: job.description,

      appliedAt: new Date().toLocaleString(),

      status: "Pending",

    };

    try {

      const response = await fetch(API, {

        method: "POST",

        headers: {

          "Content-Type": "application/json",

        },

        body: JSON.stringify(application),

      });

      if (!response.ok) {

        throw new Error("Application Failed");

      }

      /* ======================================================
                          SUCCESS
      ====================================================== */

      setShowSuccess(true);

      speak(

        "Submitted successfully. Thank you for applying."

      );

      setFormData({

        fullname: "",

        email: "",

        phone: "",

        registrationNo: "",

        resume: "",

        coverLetter: "",

      });

      setTimeout(() => {

        setShowSuccess(false);

        setShowModal(false);

      }, 2500);

    }

    catch (error) {

      console.error(error);

      speak("Application submission failed.");

      alert("Unable to submit application.");

    }

  };

  /* ==========================================================
                      RETURN NULL
  ========================================================== */

  if (!showModal) return null;
    return createPortal(

    <>

      {/* ==========================================================
                            APPLY JOB MODAL
      ========================================================== */}

      <div className="apply_job_overlay">

        <div className="apply_job_modal">

          {/* ======================================================
                              HEADER
          ====================================================== */}

          <div className="apply_job_header">

            <div className="apply_job_heading">

              <h2>Apply For Job</h2>

              <p>

                {job?.title} &bull; {job?.company}

              </p>

            </div>

            <button

              type="button"

              className="apply_job_close_btn"

              onClick={() => setShowModal(false)}

            >

              <FaTimes />

            </button>

          </div>

          {/* ======================================================
                              FORM
          ====================================================== */}

          <form

            className="apply_job_form"

            onSubmit={handleSubmit}

          >

            {/* ==================================================
                            INPUT GRID
            ================================================== */}

            <div className="apply_job_grid">

              <input

                className="apply_job_input"

                type="text"

                name="fullname"

                placeholder="Full Name"

                value={formData.fullname}

                onChange={handleChange}

                required

              />

              <input

                className="apply_job_input"

                type="email"

                name="email"

                placeholder="Email Address"

                value={formData.email}

                onChange={handleChange}

                required

              />

              <input

                className="apply_job_input"

                type="tel"

                name="phone"

                placeholder="Phone Number"

                value={formData.phone}

                onChange={handleChange}

                required

              />

              <input

                className="apply_job_input"

                type="text"

                name="registrationNo"

                placeholder="Registration Number"

                value={formData.registrationNo}

                onChange={handleChange}

                required

              />
                            <input
                className="apply_job_input apply_job_full"
                type="url"
                name="resume"
                placeholder="Resume Google Drive Link"
                value={formData.resume}
                onChange={handleChange}
                required
              />

              <textarea
                className="apply_job_textarea apply_job_full"
                rows="5"
                name="coverLetter"
                placeholder="Why are you suitable for this role?"
                value={formData.coverLetter}
                onChange={handleChange}
                required
              />

            </div>

            {/* ==================================================
                          SUBMIT BUTTON
            ================================================== */}

            <button
              type="submit"
              className="apply_job_submit_btn"
            >

              <FaPaperPlane />

              <span>

                Submit Application

              </span>

            </button>

          </form>

        </div>

      </div>

      {/* ==========================================================
                        SUCCESS POPUP
      ========================================================== */}

      {showSuccess && (

        <div className="apply_job_success_popup">

          <div className="apply_job_success_card">

            <div className="apply_job_success_icon">

              ✓

            </div>

            <h3>

              Application Submitted

            </h3>

            <p>

              Your application has been submitted successfully.

              <br />

              Our placement team will review your profile soon.

            </p>

          </div>

        </div>

      )}
            {showSuccess && (

        <div className="apply_job_success_popup">

          <div className="apply_job_success_card">

            <div className="apply_job_success_icon">

              ✓

            </div>

            <h3>

              Application Submitted

            </h3>

            <p>

              Your application has been submitted successfully.

              <br />

              Our placement team will review your profile soon.

            </p>

          </div>

        </div>

      )}

    </>,

    document.body

  );

}

export default ApplyJobModal;